import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import '../../css/components/Collapse/collapsible.css';

const ANIM_TIME = 250;

export default class Collapsible extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      $closable: null,
      $el: null,
      $content: null,
      contentHeight: null,
      isShown: true
    };
  }

  render() {
    return (
      <div>
        {this.props.children}
      </div>
    );
  }

  componentDidMount() {
    const el = ReactDOM.findDOMNode(this);
    const $el = $(el);
    const $closable = $el.find('.closable');
    const $content = $el.find('.collapsible-content');
    this.setState({
      $closable: $closable,
      $el: $el,
      contentHeight: $content.height(),
      $content: $content
    })
    $closable.addClass('active');
    $closable.on('click', () => {
      this.executeCollapsible();
    })
  }

  executeCollapsible() {
    const $content = this.state.$content;
    const isShown = this.state.isShown;
    const currentHeight = $content.height();
    const prevHeight = this.state.contentHeight;
    // Set height for content element before execute animation
    $content.css('height', $content.height());

    this.setState({
      isShown: !isShown,
      contentHeight: currentHeight
    }, () => {
      // Execute collapsible animation
      setTimeout(()=> {
        $content.css('height', isShown ? 0 : prevHeight);
        if (this.state.isShown) this.state.$closable.addClass("active");
        else this.state.$closable.removeClass("active");
      }, 1)
    })
    if (this.state.isShown) {
      setTimeout(()=> {
        $content.css('height', '');
      }, ANIM_TIME)
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Collapse/Collapsible.js
 **/